"use client";

import InfluenceSection, {
  InfluenceCreator,
} from "@/components/feature/influence/InfluenceSection";
import { Work } from "@/components/feature/influence/WorksSection";

type InfluenceMapProps = {
  /** 中央に表示するコンテンツ（CreatorCard や 作品カードなど） */
  centerContent: React.ReactNode;
  /** OUTPUT（影響を与えた）作家 */
  outputCreators: InfluenceCreator[];
  /** OUTPUT（影響を与えた）作品 */
  outputWorks: Work[];
  /** INPUT（影響を受けた）作家 */
  inputCreators: InfluenceCreator[];
  /** INPUT（影響を受けた）作品 */
  inputWorks: Work[];
  /** OUTPUTセクションを1タブ表示にする場合はtrue */
  outputSingleTab?: boolean;
  /** クリエイターの影響マップを表示するコールバック */
  onViewInfluence?: (_id: string) => void;
};

export default function InfluenceMap({
  centerContent,
  outputCreators,
  outputWorks,
  inputCreators,
  inputWorks,
  outputSingleTab = false,
  onViewInfluence,
}: InfluenceMapProps) {
  return (
    <div
      className={`relative grid min-h-[600px] animate-tab-switch grid-cols-1 items-start gap-10 lg:grid-cols-[1fr_auto_1fr] lg:gap-12`}
    >
      {/* OUTPUT セクション - スマホではINPUTの後に表示 */}
      <InfluenceSection
        title="OUTPUT"
        subtitle=""
        type="output"
        creators={outputCreators}
        works={outputWorks}
        singleTab={outputSingleTab}
        className="order-last lg:order-none"
        onViewInfluence={onViewInfluence}
      />

      {/* 中央コンテンツ - モバイルでは最初に表示 */}
      <div className="order-first lg:order-none lg:min-w-[260px] lg:max-w-[280px] lg:self-center">{centerContent}</div>

      {/* INPUT セクション */}
      <InfluenceSection
        title="INPUT"
        subtitle=""
        type="input"
        creators={inputCreators}
        works={inputWorks}
        onViewInfluence={onViewInfluence}
      />
    </div>
  );
}
